import * as React from "react";
const SvgNoTag = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}><circle cx={8} cy={8} r={8} fill="#EAEAEA" /><rect width={8} height={2} x={4} y={7} fill="#999" rx={1} /></svg>;
export default SvgNoTag;